<script setup lang="ts">
import { usePejer } from '@/Pejer'
import { ConnectedAccountsEmbed } from '@/Pejer/tables/ConnectedAccounts'
import { Loader2 } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import { toast } from 'pejer/src/components/ui/toast'
import { ref } from 'vue'

const pejer = usePejer()
const props = defineProps<{
  connectedAccountID: ConnectedAccountsEmbed.ListItem['connectedAccountID']
}>()

const isLoading = ref(false)

const redirectToOnboarding = async () => {
  isLoading.value = true
  const onboardingLink = await pejer.getOnboardingLink(props.connectedAccountID)
  isLoading.value = false
  if ('error' in onboardingLink) {
    toast({
      title: 'Error',
      description: onboardingLink.error,
      variant: 'destructive',
    })
    return
  }

  window.open(onboardingLink.data, '_blank')
}
</script>
<template>
  <Button @click.prevent.stop="redirectToOnboarding" :disabled="isLoading">
    <Loader2 v-if="isLoading" class="w-4 h-4 animate-spin mr-2" />
    <slot> Endre informasjonen </slot>
  </Button>
</template>
